var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9732 6.95091L3.50393 6.95091L8.51468 1.8056C8.91513 1.3944 8.91513 0.719604 8.51468 0.308402C8.11423 -0.102801 7.46735 -0.102801 7.0669 0.308402L0.300337 7.25667C-0.100112 7.66787 -0.100112 8.33212 0.300337 8.74333L7.0669 15.6916C7.46735 16.1028 8.11423 16.1028 8.51468 15.6916C8.91513 15.2804 8.91513 14.6161 8.51468 14.2049L3.50393 9.05964L14.9732 9.05964C15.5379 9.05964 16 8.58517 16 8.00527C16 7.42537 15.5379 6.95091 14.9732 6.95091Z",
    fill: "#82858B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.039a236c5cddd34d586cc83cb1ee4d5a.svg";
export { ForwardRef as ReactComponent };